import styled from '@emotion/styled';

export const StyledSearchInput = styled('div')({
  width: 280,
  '& input': {
    fontWeight: 500,
  },
});

export const StyledFilterSelect = styled('div')({
  width: 140,
});
